export default {
  getStyleNum(obj) {
    const count = (obj.styles || []).length
    if (this.submission.isLive && this.getUsdPrice(obj) === null) {
      return this.$tc('pages.submissions.components.preview.num_fonts', count, {
        count
      })
    }
    return this.$tc(
      'pages.submissions.components.preview.num_fonts_for',
      count,
      { count }
    )
  },
  digitPrice(price) {
    price = price * 1
    return typeof price === 'number' ? price.toFixed(2) : null
  },
  getUsdPrice(obj) {
    const item = obj?.prices?.filter(d => d.currency === 'USD')[0]
    return typeof item === 'object' ? `$ ${this.digitPrice(item.price)}` : null
  },
  getPerStyleText(obj) {
    return this.getUsdPrice(obj) === null
      ? this.$t('pages.submissions.components.preview.no_price')
      : this.$t('pages.submissions.components.preview.per_style')
  },
  getPosterUrl(id, size = 'thumbnail') {
    let src = ''
    const img = this.$store.getters['graphics/list'].filter(
      img => img.image.id === id
    )[0]
    if (typeof img === 'object' && typeof img.image === 'object') {
      const versions = img.image.versions || []
      src =
        versions.length > 0 && size === 'thumbnail'
          ? img.image.versions[0].resourceLocation
          : img.image.resourceLocation
    }
    return src || '';
  },
  getFormats(styles = []) {
    /**
     * Join formats and flavors and remove duplicates.
     */
    const formats = []
    for (const binary of this.binaries) {
      const style =
        styles.length > 0 ? styles.some(s => s.binaryId === binary.id) : true
      if (style) {
        formats.push(binary.format)
      }
    }
    /**
     * remove duplicates and empty elements
     */
    return Array.from(new Set(formats))
      .filter(f => f.length > 0)
      .join(', ')
  },
  getFeatureList(id) {
    /**
     * Get OT feature list of Binary.
     */
    const binary = this.binaries.filter(bin => bin.id === id)[0]
    let text = ''
    if (typeof binary === 'object') {
      if (typeof binary.fontInfo?.otFeatures === 'object') {
        let features = binary.fontInfo.otFeatures || []
        features = features.filter(e => e.trim() !== '') // remove empty elements
        text = features.map(f => this.$t(`data.ot_features.${f}`)).join(', ')
      }
    }
    return text
  },
  hasFeatures(id) {
    /**
     * Check, if binary has OT Features
     */
    const binary = this.binaries.filter(bin => bin.id === id)[0]
    if (binary && typeof binary.fontInfo?.otFeatures === 'object') {
      return Object.keys(binary.fontInfo.otFeatures).length > 0
    }
  },
  getBinaryFileName(binaryId) {
    const binary = this.binaries.filter(bin => bin.id === binaryId)[0]
    return typeof binary === 'object' ? binary.fileName : ''
  },
  getPosterFileName(imageId) {
    let src = ''
    const img = this.$store.getters['graphics/list'].filter(
      img => img.image.id === imageId
    )[0]
    if (typeof img === 'object' && typeof img.image === 'object') {
      src = img.image.fileName
    }
    return src
  },
  changePillStatus () {
    this.showPills = !this.showPills
  }
}
